import styled, { css } from "styled-components";
import COLORS from "../../constants/colors";
import { getMobileCSS } from "../../methods/getMobileCSS";
const errorInputStyle = css`
    border-color: ${COLORS.RED} !important;
`;

const defaultWrapperStyles = css`
    .otp-wrapper {
        display: flex;
        justify-content: space-between;
        gap: 26px;

        ${getMobileCSS(css`
            gap: 10px;
        `)}
    }

    .otp-input {
        display: inline-block;
        height: 62px !important;
        width: 62px !important;
        font-size: 24px;
        vertical-align: middle;
        text-align: center;
        outline: none;
        border: 1px solid ${COLORS.GREY_200};
        border-radius: 4px;
        box-sizing: border-box;

        &:focus {
            border-color: ${COLORS.BLUE};
            caret-color: ${COLORS.BLUE};
        }

        ${getMobileCSS(css`
            height: 56px !important;
            width: 56px !important;
        `)}
    }
`;

const sharedInputStyles = css`
    .otp-input {
        &::-webkit-outer-spin-button,
        &::-webkit-inner-spin-button {
            appearance: none;
            -webkit-appearance: none;
        }

        &[type="number"] {
            -moz-appearance: textfield;
        }
    }
`;

export const StyledOTPInputWrapper = styled.div<{
    errorMsg?: string;
    $inputClassName?: string;
}>`
    display: flex;
    flex-direction: column;
    gap: 10px;

    /**
     * The OTP library selects a box's digit whenever it takes focus, so typing replaces it
     * rather than appending. Worth keeping, but on a single centred character the selection
     * highlight reads as a coloured block behind the digit. Matched on the element so it
     * holds for a caller-supplied inputClassName too.
     */
    input::selection {
        background: transparent;
    }

    ${sharedInputStyles}
    ${({ $inputClassName }) => ($inputClassName ? null : defaultWrapperStyles)}

    ${({ errorMsg, $inputClassName }) =>
        errorMsg
            ? $inputClassName
                ? css`
                      .${$inputClassName} {
                          ${errorInputStyle}
                      }
                  `
                : css`
                      .otp-input {
                          ${errorInputStyle}
                      }
                  `
            : null}
`;
